<div class="modal-header">
    <h2 class="event-title">{{ event!.title }}</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-md-6">
            <p class="event-date text-muted">{{ event!.start | date: 'dd.MM.yyyy'}}</p>
            <p class="event-body" [innerHTML]="event!.description"></p>
            <p class="event-organisation"><strong>{{ event!.organisationName }}</strong></p>
        </div>

        <div class="col-md-6 text-center" style="border-left: 1px solid #d0d0d0;">
            <img [src]="event!.imageRef" alt="News Image" class="news-image img-fluid rounded">
        </div>
    </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary" (click)="closeModal()">Zapri</button>
</div>